import React from 'react';
import { ExpansionPanel, ExpansionPanelContent, ExpansionPanelTrigger } from '@eventbrite/marmalade';
import type { FAQ } from '../../types';
import styles from './FAQItem.module.scss';

interface FAQItemProps {
  faq: FAQ;
}

export const FAQItem: React.FC<FAQItemProps> = ({ faq }) => {
  if (!faq.question?.trim() || !faq.answer?.trim()) {
    return null;
  }

  return (
    <ExpansionPanel className={styles.faqItem}>
      <ExpansionPanelTrigger className={styles.question}>{faq.question}</ExpansionPanelTrigger>
      <ExpansionPanelContent>
        <div className={styles.answer}>{faq.answer}</div>
      </ExpansionPanelContent>
    </ExpansionPanel>
  );
};
